import React, { useContext, useEffect, useReducer, useState } from "react";
// @ts-ignore
import Sticky from 'react-stickynode';
import { Button, Card, Col, Container, Row, Table, Breadcrumb, Image, Badge, Form } from "react-bootstrap";
import CardHeader from "react-bootstrap/CardHeader";
import PersonsSelect from "../../components/PersonsSelect";
import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { PersonModel } from "../../models/PersonModel";
import PairedPersonCard, { calculateAge } from "./PairedPersonCard";
import Loader from "../../components/messages/Loader";
import { PairedPersonType, PairingResponse } from "../../types/PersonType";
import { ImageUploadProvider, ImageUploadProviderContext } from "../../providers/ImageUploadProvider";
import ImageUploader from "../../components/ImageUploader";
import { OptionType } from "../../types/CommonType";
import CustomSelect from "../../components/form/CustomSelect";
import "./styles/pairing-add-page.css";
import { RodSelectItem, RodSelectList, RodType } from "../../types/RodType";
import { RodModel } from "../../models/RodModel";
import { RodSelectListReducer } from "../../reducers/PersonReducer";
import RodsSelectList from "./components/RodsSelectList";
import { PairingModel } from "../../models/PairingModel";
import { toast } from "react-toastify";
import { useAPI } from "../../hooks/useAPI";
import download from 'downloadjs';
import Error from "../../components/messages/Error";
import { useAuth } from "../../hooks/useAuth";
import TranslateTerms from "../../components/TranslateTerms";
import { OptionsContext } from "../../providers/OptionsContextProvider";
import { FormattedMessage, useIntl } from "react-intl";
import { LANG_CITY, LANG_COMMON_ALL, LANG_COMMON_AVAILABLE, LANG_COMMON_BACK, LANG_COMMON_CHOOSE, LANG_COMMON_CLINIC, LANG_COMMON_DATA, LANG_COMMON_DONATED_MATERIAL, LANG_COMMON_NEW, LANG_COMMON_PAIRING, LANG_COMMON_PAIRINGS, LANG_COMMON_SAVE, LANG_COMMON_SEARCH, LANG_ERROR, LANG_MAX_AGE, LANG_PERSON_AGE, LANG_PERSON_AGE_ROD, LANG_PERSON_BLOOD_TYPE, LANG_PERSON_EYES_COLOR, LANG_PERSON_HAIR_COLOR, LANG_PERSON_HAIR_TYPE, LANG_PERSON_HEIGHT, LANG_PERSON_RACE, LANG_PERSON_RH_FACTOR, LANG_PERSON_SKIN_COLOR, LANG_ROD_AVAILABILITY, LANG_STATE } from "../../lang";
import mixpanel from "mixpanel-browser";
import BusinessSelect from "../../components/form/BusinessSelect";
import PairingAddModal from "./components/PairingAddModal";
import BusinessesSelect from "../../components/form/BusinessesSelect";
import StateList from "../../components/form/StateList";
import { stat } from "fs";
import CityList from "../../components/form/CityList";
import { max } from "moment";

const PairingAddPage = () => {
    const intl = useIntl();
    const options = useContext(OptionsContext);
    const { id } = useParams();
    const location = useLocation();
    const [pairingResult, setPairingResult] = useState<PairingResponse | undefined>(undefined);
    const [showChildView, setShowChildView] = useState(false);
    const [showAvatarView, setShowAvatarView] = useState(false);
    const [loadingPairing, setLoadingPairing] = useState(true);
    const [loadingPage, setLoadingPage] = useState(true);
    const [searchParams, setSearchParams] = useSearchParams(location.search);
    const [bloodType, setBloodType] = useState<string>(searchParams.get("blood_type") || "");
    const [availableOnly, setAvailableOnly] = useState<boolean>(true);
    const [rhFactor, setRhFactor] = useState<string>(searchParams.get("rh_factor") || "");
    const [race, setRace] = useState<string>(searchParams.get("race") || "");
    const [businessIds, setBusinessIds] = useState<string | number>(searchParams.get("business_ids") || "");
    const [skinColor, setSkinColor] = useState<string>(searchParams.get("skin_color") || "");
    const [hairColor, setHairColor] = useState<string>(searchParams.get("hair_color") || "");
    const [hairType, setHairType] = useState<string>(searchParams.get("hair_type") || "");
    const [eyesColor, setEyesColor] = useState<string>(searchParams.get("eyes_color") || "");
    const [height, setHeight] = useState<string>(searchParams.get("height") || "");
    const [donatedMaterialType, setDonatedMaterialType] = useState<string>(searchParams.get("donated_material_type") || "");
    const [stateId, setStateId] = useState<string>(searchParams.get("state_id") || "");
    const [cityId, setCityId] = useState<string>(searchParams.get("city_id") || "");
    const [filters, setFilters] = useState({
        skin_color: skinColor,
        hair_color: hairColor,
        hair_type: hairType,
        eyes_color: eyesColor,
        height,
        available_only: availableOnly,
        business_ids: businessIds,
        donated_material_type: donatedMaterialType,
        state_id: stateId,
        city_id: cityId,
        max_age: searchParams.get("max_age") || ""
    });

    const [donor, setDonor] = useState<number | undefined>(undefined);
    const [receiver, setReceiver] = useState<number | undefined>(undefined);

    const [highestFaceSimilarityPerson, setHighestFaceSimilarityPerson] = useState<PairedPersonType | undefined>(undefined);
    const [saving, setSaving] = useState(false);
    const [loadingPdf, setLoadingPdf] = useState(false);
    const [errorPdf, setErrorPdf] = useState(false);
    const [selectedPersonIds, setSelectedPersonIds] = useState<number[]>([]);

    const navigate = useNavigate();
    const { hasAbility } = useAuth();
    const { api } = useAPI();

    const loadPairing = (
        bloodType: string | null,
        rhFactor: string | null,
        race: string | null,
        filters: any = {}
    ) => {
        if (id !== undefined) {
            setSearchParams({
                rh_factor: (rhFactor !== null) ? rhFactor : "",
                blood_type: (bloodType !== null) ? bloodType : "",
                race: (race !== null) ? race : "",
                ...filters
            }, { replace: true });

            setLoadingPairing(true);
            PersonModel().pairing(id, {
                blood_type: bloodType,
                rh_factor: rhFactor,
                race: race,
                ...filters
            }).then((resp) => {
                if (typeof resp !== "boolean") {
                    setSelectedPersonIds(resp.candidates.map((person) => person.id));
                    setHighestFaceSimilarityPerson(getHighestFaceSimilarityPerson(resp.candidates))
                    setPairingResult(resp);
                    if (resp.reference.type === 'R') {
                        setReceiver(resp.reference.id);
                    } else {
                        setDonor(resp.reference.id);
                    }
                }

                setLoadingPairing(false);
                setLoadingPage(false);
            })
        }
    }

    const downloadPdf = (avatar: boolean = false) => {
        if (id !== undefined) {
            try {
                mixpanel.track("Matching Printed");
            } catch (e) { }
            setLoadingPdf(true);
            setErrorPdf(false);
            api().downloadPDF(PersonModel().getPairingUrl(id, {
                'donor': (donor !== undefined) ? donor : -1,
                //'rod_list': rodList,
                'blood_type': bloodType,
                'rh_factor': rhFactor,
                'race': race,
                'print': 'Y',
                'avatar': avatar,
                'selected': selectedPersonIds.join(","),
                ...filters
            })).then(response => {
                const content = response.headers['content-type'];
                download(response.data, "pareamento", content);
                setLoadingPdf(false);
            })
                .catch(error => {
                    setLoadingPdf(false);
                    setErrorPdf(true);
                });
        }
    }

    const getHighestFaceSimilarityPerson = (persons: Array<PairedPersonType>) => {
        let highestSimilarity = 0;
        let person = undefined;
        for (let i in persons) {
            if (parseFloat(persons[i].face_similarity) > highestSimilarity) {
                highestSimilarity = parseFloat(persons[i].face_similarity);
                person = persons[i];
            }
        }

        return person;
    }

    useEffect(() => {
        loadPairing(bloodType, rhFactor, race, filters);
    }, []);

    return (
        <>

            {donor !== undefined && receiver !== undefined && pairingResult && (
                <PairingAddModal
                    show={true}
                    reference={pairingResult.reference}
                    selected={pairingResult.candidates.filter((item) => pairingResult.reference.type === "R" ? item.donor === donor : item.receiver === receiver)[0]}
                    bloodType={bloodType}
                    rhFactor={rhFactor}
                    race={race}
                    onHide={() => {
                        if (pairingResult.reference.type === "R") {
                            setDonor(undefined);
                        } else {
                            setReceiver(undefined);
                        }
                    }}
                    onSave={() => {
                        try {
                            mixpanel.track("Pairing Created");
                            mixpanel.people.increment({ 'pairings_count': 1 });
                        } catch (e) { }
                        toast.success("Pareamento salvo com sucesso!");
                        navigate("/admin/pairing");
                    }}
                />
            )}



            {loadingPage && (<Loader fullscreen={true} />)}
            {(saving || loadingPdf) && (<Loader fullscreen={true} />)}
            {errorPdf && (<Error message={intl.formatMessage(LANG_ERROR)} show={errorPdf} onHide={() => setErrorPdf(false)} />)}
            {!loadingPage && (
                <div className="bg-pattern pairing-add-page">
                    <Container style={{ 'paddingBottom': '200px' }}>
                        <Row>
                            <Breadcrumb>
                                <Breadcrumb.Item active><Link to={'/admin/pairing'}>{intl.formatMessage(LANG_COMMON_PAIRINGS)}</Link></Breadcrumb.Item>
                                <Breadcrumb.Item active>{intl.formatMessage(LANG_COMMON_NEW)}{" "}{intl.formatMessage(LANG_COMMON_PAIRING)}</Breadcrumb.Item>
                            </Breadcrumb>
                        </Row>
                        <Row>
                            <Col lg={11}>
                                <Card>
                                    <CardHeader className={'d-flex'} style={{ "padding": "4px 1rem" }}>
                                        <div className="card-title h5 w-100">
                                            <div className="row">
                                                <div className="col-md-6" style={{ "paddingTop": "3px" }}>
                                                    {intl.formatMessage(LANG_COMMON_DATA)} {" "}
                                                </div>
                                                <div className="text-end col-md-6">
                                                    <a
                                                        href="#"
                                                        className="btn-icon me-2"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            downloadPdf(true);
                                                        }}
                                                    >
                                                        <i className="bi bi-person-vcard" />
                                                    </a>
                                                    <a
                                                        href="#"
                                                        className="btn-icon"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            downloadPdf();
                                                        }}
                                                    ><i className="bi bi-printer" /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </CardHeader>
                                    <Card.Body>
                                        <Row>
                                            <Col lg={{ span: 3 }}>
                                                <ImageUploadProvider url={
                                                    showAvatarView ? `/api/person/${pairingResult?.reference.id}/photo/avatar` :
                                                        (!showChildView) ? `/api/person/${pairingResult?.reference.id}/photo` : `/api/person/${pairingResult?.reference.id}/photo/child`
                                                } onChange={() => { }}>
                                                    <ImageUploadProviderContext.Consumer>
                                                        {({ url, onChange, onRemove, loading, hasDownloadError, hasUploadError, download }) => (
                                                            <ImageUploader
                                                                hasUploadError={hasUploadError}
                                                                hasDownloadError={hasDownloadError}
                                                                download={download}
                                                                loading={loading}
                                                                height={304}
                                                                width={304}
                                                                url={url}
                                                                onChange={onChange}
                                                                onRemove={onRemove}
                                                                uploadUrl={`/api/person/${pairingResult?.reference.id}/photo`}
                                                                edit={false}
                                                                removeUrl={""}
                                                                photoLabel={pairingResult?.reference.name}
                                                                photoSubLabel=""
                                                                showDownload={showAvatarView}
                                                                showQuality={true}
                                                                faceData={(pairingResult?.reference.face_details !== null && pairingResult?.reference.face_details !== undefined) ? JSON.parse(pairingResult?.reference.face_details) : undefined}
                                                            />
                                                        )}
                                                    </ImageUploadProviderContext.Consumer>
                                                </ImageUploadProvider>
                                                <div className="px-3">
                                                    <label className="form-label mt-3">
                                                        <input
                                                            type="checkbox"
                                                            checked={showChildView}
                                                            onChange={() => setShowChildView(!showChildView)} />
                                                        {" "}
                                                        <FormattedMessage
                                                            id="pairing.show_kid_picture"
                                                            defaultMessage={"Exibir foto de criança"}
                                                        />
                                                    </label>
                                                </div>
                                                <div className="px-3">
                                                    <label className="form-label mt-3">
                                                        <input
                                                            type="checkbox"
                                                            checked={showAvatarView}
                                                            onChange={() => setShowAvatarView(!showAvatarView)} />
                                                        {" "}
                                                        <FormattedMessage
                                                            id="pairing.show_avatar"
                                                            defaultMessage={"Exibir foto de avatar"}
                                                        />
                                                    </label>
                                                </div>
                                                <div className="px-3 pairing-aspects">
                                                    <hr style={{ "marginTop": "10px" }} />
                                                    <ul>

                                                        <li>{intl.formatMessage(LANG_PERSON_RACE)}: {PersonModel().getOption(pairingResult?.reference.race, options.personOptions?.getRaceTypes())?.label}</li>
                                                        <li>{intl.formatMessage(LANG_PERSON_SKIN_COLOR)}: {PersonModel().getOption(pairingResult?.reference.skin_color, options.personOptions?.getSkinColors())?.label}</li>
                                                        <li>{intl.formatMessage(LANG_PERSON_EYES_COLOR)}: {PersonModel().getOption(pairingResult?.reference.eyes_color, options.personOptions?.getEyesColors())?.label}</li>
                                                        <li>{intl.formatMessage(LANG_PERSON_HAIR_COLOR)}: {PersonModel().getOption(pairingResult?.reference.hair_color, options.personOptions?.getHairColors())?.label}</li>
                                                        <li>{intl.formatMessage(LANG_PERSON_HAIR_TYPE)}: {PersonModel().getOption(pairingResult?.reference.hair_type, options.personOptions?.getHairTypes())?.label}</li>
                                                        <li>{intl.formatMessage(LANG_PERSON_HEIGHT)}: {pairingResult?.reference.height_number}m</li>
                                                        <li>{intl.formatMessage(LANG_PERSON_AGE)}: {calculateAge(pairingResult?.reference.birth_date)} anos</li>
                                                    </ul>
                                                </div>
                                                <div className="p-3">
                                                    <hr style={{ "marginTop": 0 }} />

                                                    <label htmlFor="exampleInputEmail1" className="form-label"><FormattedMessage {...LANG_COMMON_CLINIC} /></label>
                                                    <BusinessesSelect
                                                        onChange={(business_id) => {
                                                            const v = business_id !== undefined ? business_id : "";
                                                            setBusinessIds(v);
                                                            setFilters({
                                                                ...filters,
                                                                business_ids: v
                                                            });
                                                        }}
                                                    />

                                                    <label className="form-label"><FormattedMessage {...LANG_ROD_AVAILABILITY} />:</label>
                                                    <CustomSelect
                                                        name="available_only"
                                                        options={[
                                                            { "label": <FormattedMessage {...LANG_COMMON_AVAILABLE} />, "value": true },
                                                            { "label": <FormattedMessage {...LANG_COMMON_ALL} />, "value": false }
                                                        ]}
                                                        onChange={(option: OptionType) => {
                                                            setAvailableOnly(option.value);
                                                            setFilters({
                                                                ...filters,
                                                                available_only: option.value
                                                            });
                                                        }}
                                                        value={availableOnly}
                                                        placeholder={`${intl.formatMessage(LANG_COMMON_CHOOSE)}...`}
                                                        isMulti={false}
                                                        isSearchable={false}
                                                        isClearable={false}
                                                    />
                                                    <label className="form-label"><FormattedMessage {...LANG_COMMON_DONATED_MATERIAL} />:</label>
                                                    <CustomSelect
                                                        name="donated_material_type"
                                                        options={PersonModel().getDonatedMaterialTypes()}
                                                        onChange={(options: Array<OptionType>) => {
                                                            const selected = options.map((item) => {
                                                                return item.value;
                                                            }).join(",");
                                                            setDonatedMaterialType(selected);
                                                            setFilters({
                                                                ...filters,
                                                                donated_material_type: selected
                                                            });
                                                        }}
                                                        value={donatedMaterialType}
                                                        placeholder={`${intl.formatMessage(LANG_COMMON_CHOOSE)}...`}
                                                        isMulti={true}
                                                        isSearchable={false}
                                                        isClearable={false}
                                                    />
                                                    <label className="form-label"><FormattedMessage {...LANG_PERSON_BLOOD_TYPE} />:</label>
                                                    <CustomSelect
                                                        name="blood_type"
                                                        options={PersonModel().getBloodTypes()}
                                                        onChange={(options: Array<OptionType>) => {
                                                            const selected = options.map((item) => {
                                                                return item.value;
                                                            }).join(",");
                                                            setBloodType(selected);
                                                        }}
                                                        value={bloodType}
                                                        placeholder={`${intl.formatMessage(LANG_COMMON_CHOOSE)}...`}
                                                        isMulti={true}
                                                        isSearchable={false}
                                                        isClearable={false}
                                                    />
                                                    <label className="form-label"><FormattedMessage {...LANG_PERSON_RH_FACTOR} />:</label>
                                                    <CustomSelect
                                                        name="rh_factor"
                                                        options={options.personOptions?.getRHFactorTypes()}
                                                        onChange={(options: Array<OptionType>) => {
                                                            const selected = options.map((item) => {
                                                                return item.value;
                                                            }).join(",");
                                                            setRhFactor(selected);
                                                        }}
                                                        value={rhFactor}
                                                        placeholder={`${intl.formatMessage(LANG_COMMON_CHOOSE)}...`}
                                                        isMulti={true}
                                                        isSearchable={false}
                                                        isClearable={false}
                                                    />

                                                    <label className="form-label mt-2"><FormattedMessage {...LANG_PERSON_RACE} />:</label>
                                                    <CustomSelect
                                                        name="blood_type"
                                                        options={options.personOptions?.getRaceTypes()}
                                                        onChange={(options: Array<OptionType>) => {
                                                            const selected = options.map((item) => {
                                                                return item.value;
                                                            }).join(",");
                                                            setRace(selected);
                                                        }}
                                                        value={race}
                                                        placeholder={`${intl.formatMessage(LANG_COMMON_CHOOSE)}...`}
                                                        isMulti={true}
                                                        isSearchable={false}
                                                        isClearable={false}
                                                    />

                                                    <label className="form-label mt-2"><FormattedMessage {...LANG_PERSON_SKIN_COLOR} />:</label>
                                                    <CustomSelect
                                                        name="skin_color"
                                                        options={options.personOptions?.getSkinColors()}
                                                        onChange={(options: Array<OptionType>) => {
                                                            const selected = options.map((item) => {
                                                                return item.value;
                                                            }).join(",");
                                                            setSkinColor(selected);
                                                            setFilters({
                                                                ...filters,
                                                                skin_color: selected
                                                            });
                                                        }}
                                                        value={skinColor}
                                                        placeholder={`${intl.formatMessage(LANG_COMMON_CHOOSE)}...`}
                                                        isMulti={true}
                                                        isSearchable={false}
                                                        isClearable={false}
                                                    />

                                                    <label className="form-label mt-2"><FormattedMessage {...LANG_PERSON_HAIR_COLOR} />:</label>
                                                    <CustomSelect
                                                        name="hair_color"
                                                        options={options.personOptions?.getHairColors()}
                                                        onChange={(options: Array<OptionType>) => {
                                                            const selected = options.map((item) => {
                                                                return item.value;
                                                            }).join(",");
                                                            setHairColor(selected);
                                                            setFilters({
                                                                ...filters,
                                                                hair_color: selected
                                                            });
                                                        }}
                                                        value={hairColor}
                                                        placeholder={`${intl.formatMessage(LANG_COMMON_CHOOSE)}...`}
                                                        isMulti={true}
                                                        isSearchable={false}
                                                        isClearable={false}
                                                    />

                                                    <label className="form-label mt-2"><FormattedMessage {...LANG_PERSON_HAIR_TYPE} />:</label>
                                                    <CustomSelect
                                                        name="hair_type"
                                                        options={options.personOptions?.getHairTypes()}
                                                        onChange={(options: Array<OptionType>) => {
                                                            const selected = options.map((item) => {
                                                                return item.value;
                                                            }).join(",");
                                                            setHairType(selected);
                                                            setFilters({
                                                                ...filters,
                                                                hair_type: selected
                                                            });
                                                        }}
                                                        value={hairType}
                                                        placeholder={`${intl.formatMessage(LANG_COMMON_CHOOSE)}...`}
                                                        isMulti={true}
                                                        isSearchable={false}
                                                        isClearable={false}
                                                    />

                                                    <label className="form-label mt-2"><FormattedMessage {...LANG_PERSON_EYES_COLOR} />:</label>
                                                    <CustomSelect
                                                        name="hair_type"
                                                        options={options.personOptions?.getEyesColors()}
                                                        onChange={(options: Array<OptionType>) => {
                                                            const selected = options.map((item) => {
                                                                return item.value;
                                                            }).join(",");
                                                            setEyesColor(selected);
                                                            setFilters({
                                                                ...filters,
                                                                eyes_color: selected
                                                            });
                                                        }}
                                                        value={eyesColor}
                                                        placeholder={`${intl.formatMessage(LANG_COMMON_CHOOSE)}...`}
                                                        isMulti={true}
                                                        isSearchable={false}
                                                        isClearable={false}
                                                    />

                                                    <label className="form-label mt-2"><FormattedMessage {...LANG_PERSON_HEIGHT} />:</label>
                                                    <CustomSelect
                                                        name="hair_type"
                                                        options={PersonModel().getHeightTypes()}
                                                        onChange={(options: Array<OptionType>) => {
                                                            const selected = options.map((item) => {
                                                                return item.value;
                                                            }).join(",");
                                                            setHeight(selected);
                                                            setFilters({
                                                                ...filters,
                                                                height: selected
                                                            });
                                                        }}
                                                        value={height}
                                                        placeholder={`${intl.formatMessage(LANG_COMMON_CHOOSE)}...`}
                                                        isMulti={true}
                                                        isSearchable={false}
                                                        isClearable={false}
                                                    />

                                                    <Form.Label className="mt-2">{intl.formatMessage(LANG_STATE)}</Form.Label>
                                                    <StateList
                                                        name="state_id"
                                                        value={stateId}
                                                        onChange={(state_id: string) => {
                                                            setStateId(state_id);
                                                            setFilters({
                                                                ...filters,
                                                                state_id: state_id
                                                            });
                                                        }}
                                                        className={'form-select form-select-solid form-select-lg form-control'}
                                                    />
                                                    <div className="row">
                                                        <div className="col-lg-12" style={{position: 'relative'}}>
                                                            <Form.Label>{intl.formatMessage(LANG_CITY)}</Form.Label>
                                                            <CityList
                                                                state_id={stateId}
                                                                name="city_id"
                                                                value={cityId}
                                                                onChange={(city_id: string) => {
                                                                    setCityId(city_id);
                                                                    setFilters({
                                                                        ...filters,
                                                                        city_id: city_id
                                                                    });
                                                                }}
                                                                className={'form-select form-select-solid form-select-lg form-control'}
                                                            />
                                                        </div>
                                                    </div>

                                                    <Form.Label>{intl.formatMessage(LANG_MAX_AGE)}</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="max_age"
                                                        value={filters.max_age}
                                                        min={0}
                                                        max={80}
                                                        onChange={(e) => {
                                                            setFilters({
                                                                ...filters,
                                                                max_age: e.target.value
                                                            });
                                                        }}
                                                        className={'form-control'}
                                                    />

                                                    <br />
                                                    <form action="" onSubmit={(e) => {
                                                        e.preventDefault();
                                                        //savePairing();
                                                    }}>
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <Button variant="outline-light" size={'lg'} className="btn-custom btn-custom-light btn-custom-small text-uppercase w-100">{intl.formatMessage(LANG_COMMON_BACK)}</Button>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <Button
                                                                    variant="primary"
                                                                    className="btn-custom bg-custom-gradient btn-custom-small text-uppercase w-100"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        loadPairing(bloodType, rhFactor, race, filters);
                                                                    }}
                                                                >{intl.formatMessage(LANG_COMMON_SEARCH)}</Button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </Col>
                                            <Col lg={9}>
                                                <Row>
                                                    {loadingPairing && (
                                                        <Col lg={12}>
                                                            <Loader fullscreen={true} />
                                                        </Col>
                                                    )}
                                                    {!loadingPairing && pairingResult?.candidates.map((item) => (
                                                        <Col lg={4} className={'mb-4'} key={item.donor}>
                                                            <PairedPersonCard
                                                                stared={
                                                                    (pairingResult.reference.type === "R") ?
                                                                        highestFaceSimilarityPerson?.donor === item.donor :
                                                                        highestFaceSimilarityPerson?.receiver === item.receiver
                                                                }
                                                                type={pairingResult.reference.type}
                                                                paired={item}
                                                                showChildPhoto={showChildView}
                                                                showAvatarPhoto={showAvatarView}
                                                                onSelectReport={(selected) => {
                                                                    if (!selected) {
                                                                        setSelectedPersonIds(selectedPersonIds.filter((id) => id !== item.id));
                                                                    } else {
                                                                        setSelectedPersonIds([...selectedPersonIds, item.id]);
                                                                    }
                                                                }}
                                                                onSelect={(paired) => {
                                                                    if (pairingResult.reference.type === "R") {
                                                                        setDonor(paired.donor);
                                                                    } else {
                                                                        setReceiver(paired.receiver);
                                                                    }
                                                                }} />
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>

                        </Row>
                    </Container>
                </div>
            )}
        </>
    );
}

export default PairingAddPage;